<template>
    <div class="gas-consumption">

        <el-popover
            placement="bottom-start"
            :width="350"
            :title="title"
            :visible-arrow="false"
            :popper-class="`smr-popper smr-popper--dark-title`"
            trigger="click"
            v-model="popperOpen"
            @show="popperShowHandler"
            @hide="popperHideHandler"
        >
            <div class="smr-popper__close smr-popper__close--show-always" @click="popperCloseClickHandler">
                <icon><IconClose/></icon>
            </div>
            <div class="gas-consumption__fields">
                <div class="form__field-row ui-spread-center-vertically">
                    <div class="copy black">Preis pro Liter <span class="copy-light">(€)</span></div>
                    <SmrInput
                        class="smr-input--small"
                        :value="data.gasPrice"
                        placeholder="0,0"
                        inputType="number"
                        @change="fieldChangeHandler($event, 'gasPrice')">
                    </SmrInput>
                </div>
                <div class="form__field-row ui-spread-center-vertically">
                    <div class="copy black">Verbrauch pro 100 km <span class="copy-light">(l)</span></div>
                    <SmrInput
                        class="smr-input--small"
                        :value="data.gasConsumption"
                        placeholder="0,0"
                        inputType="number"
                        @change="fieldChangeHandler($event, 'gasConsumption')">
                    </SmrInput>
                </div>
            </div>
            <div class="gas-consumption__actions">
                <SmrButton color="grey" @click.native="resetHandler">Zurücksetzen</SmrButton>
                <SmrButton @click.native="saveHandler">Übernehmen</SmrButton>
            </div>
            <div slot="reference">
                <Icon class="gas-consumption__edit copy-light">
                    <IconEdit />
                </Icon>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getVehicleLabel } from '@/utils/poi-detail-labels'
import Icon from '@/components/Icon.vue'
import IconEdit from '@/components/icons/IconEdit.vue'
import IconClose from '@/components/icons/IconClose.vue'
import SmrInput from '@/components/form/SmrInput.vue'
import SmrButton from '@/components/SmrButton.vue'
import gasConsumptionSettingsDefaults from '@data/gasConsumptionSettingsDefaults';
import { setPermanentData } from '@/utils/browser-storage';
import { trackEvent } from '@/utils/tracking'

export default {
    components: {
        Icon,
        IconEdit,
        IconClose,
        SmrInput,
        SmrButton,
    },
    props: {
        routeMode: {
            type: String
        }
    },
    data() {
        return {
            popperOpen: false,
            data: {
                gasConsumption: 0,
                gasPrice: 0,
            }
        }
    },
    computed: {
        ...mapGetters(['mobile', 'gasConsumptionSettings']),
        title() {
            return `Spritkosten berechnen (${getVehicleLabel(this.routeMode)})`
        },
        routeModeKey() {
            return this.routeMode.toLowerCase()
        }
    },
    created() {
        this.setInitialData();
    },
    methods: {
        popperShowHandler() {
            trackEvent({ category: 'Route Detail', action: 'Edit', label: 'Gas Consumption' });

            if(this.mobile) {
                this.$store.commit('setDim', true)
            }
        },
        popperHideHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', false)
            }
        },
        popperCloseClickHandler() {
            this.popperOpen = false;
        },
        fieldChangeHandler(output, dataKey) {
            this.data[dataKey] = output;
        },
        resetHandler() {
            this.resetValues()
        },
        saveHandler() {
            this.saveValues()
        },
        setInitialData() {
            const gasConsumptionSettings = this.gasConsumptionSettings[this.routeModeKey]
            if(!gasConsumptionSettings) return
            this.data = {
                gasConsumption: gasConsumptionSettings.gasConsumption,
                gasPrice: gasConsumptionSettings.gasPrice,
            };
        },
        resetValues() {
            const defaultSettings = gasConsumptionSettingsDefaults[this.routeModeKey]
            this.data = {
                gasConsumption: defaultSettings.gasConsumption,
                gasPrice: defaultSettings.gasPrice,
            }
            this.saveSettings()
        },
        saveValues() {
            this.saveSettings()
        },
        saveSettings() {
            const newData = JSON.parse(JSON.stringify(this.gasConsumptionSettings))
            newData[this.routeModeKey] = { ...newData[this.routeModeKey], ...this.data }
            this.$store.commit('setGasConsumptionSettings', newData);
            setPermanentData('gas-consumption-settings', newData);
            this.popperOpen = false

            trackEvent({ category: 'Route Detail', action: 'Save', label: 'Gas Consumption' });
        }
    }
}
</script>

<style lang="scss">
.gas-consumption {
    &__edit {
        cursor: pointer;
    }

    &__fields {
        padding: 16px 0;
        border-bottom: 1px solid $color-black-005;
    }

    &__actions {
        display: grid;
        gap: 6px;
        padding: 16px 0;
    }
}
</style>